import { float } from "../../../../../../utils/formats";

const calculateTotalBonusPercent = ({
    method_bonus,
    fee,
    deposit_bonus
}) => {
    let amount = 1;
    if(fee > 0) amount = amount * (1 - (fee / 100)); // 1 * 0.9

    amount = amount * (1 + ((method_bonus + deposit_bonus) / 100));

    return float((amount - 1) * 100);
}

export default ({
    available=true,
    bonus=0,
    deposit_bonus=0,
    fee=0,
    crypto=false
}) => {
    if(!available)
        return <div className="status">Soon</div>;

    const total_mutliplier = calculateTotalBonusPercent({method_bonus: bonus, fee, deposit_bonus});

    if(crypto)
        return (
            <div className="status crypto">
                <span className="rg">Bonus <b>+{total_mutliplier}%</b></span>
                <span className="xs"><b>+{total_mutliplier}%</b></span>
            </div>
        )

    if(total_mutliplier > 0)
        return (
            <div className="status bonus">
                <span className="rg">Bonus <b>+{total_mutliplier}%</b></span>
                <span className="xs"><b>+{total_mutliplier}%</b></span>
            </div>
        )

    if(total_mutliplier === 0)
        return <div className="status active">No fee</div>;

    return (
        <div className="status fee">
            <span className="rg">Fee <b>{total_mutliplier}%</b></span>
            <span className="xs"><b>{total_mutliplier}%</b></span>
        </div>
    )

    return <div className="status active">No fee</div>;
}